
export const getUserRol = () =>{
    let empresa = JSON.parse(localStorage.getItem("empresaData"));
    let rol = empresa.map(data => data.Rol);
    return rol;
}